import * as React from 'react'
import styled from 'styled-components'
import { VideoData } from '../../../interfaces'
import SwipeableViews from 'react-swipeable-views'
import { Tab, Tabs, useMediaQuery } from '@material-ui/core'
import { styled as styling } from '@material-ui/styles'
import CommentsDetails from './CommentsDetails'
import ActivityDetails from './ActivityDetails'
import LeaderboardDetails from './LeaderboardDetails'
import { useSubscription } from '@apollo/client'
import { Query_Root } from '../../../graphql/indexer-graphql-types'
import { COLLECTORS_SUBSCRIPTION, PURCHASES_SUBSCRIPTION } from '../../../graphql/graphql-queries'

const OuterDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  margin-left: 12px;
  margin-right: 12px;

  background: linear-gradient(rgb(25, 25, 25), rgb(18, 18, 18));
  border-radius: 15px;
  padding: 15px;

  border-color: #323232;
  border-width: 1px;
  border-style: solid;

  width: calc(100%-30px);

  @media (min-width: 43em) {
    margin: 0;
    margin-top: 25px;
    padding: 25px;
    width: calc(100%-50px);
  }
`

const SwipeDiv = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`

const StyledTabs = styling(Tabs)({
  borderBottom: '1px solid #323232',
  '& .MuiTabs-indicator': {
    backgroundColor: 'white',
  },
  '& .MuiTabs-scrollButtons.Mui-disabled': {
    opacity: 0.3,
  },
})

const StyledTab = styling((props) => <Tab disableRipple {...props} />)((props) => ({
  textTransform: 'none',
  minWidth: 0,
  fontWeight: 700,
  opacity: 1,
  fontSize: props.isMobile ? '18px' : '26px',
  textAlign: 'left',
  padding: 0,
  paddingBottom: '10px',
  marginRight: props.label !== '' ? (props.isMobile ? '25px' : '50px') : '0px',
  color: '#aaa',
  fontFamily: [
    'Inter',
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Roboto',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif',
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(','),
  '&:hover': {
    color: 'white',
    opacity: 1,
  },
  '&.Mui-selected': {
    color: 'white',
  },
}))

type Props = {
  video: VideoData
}

const SocialDetails = ({ video }: Props): JSX.Element => {
  const [index, setIndex] = React.useState(0)
  const [swipeableActions, setSwipeableActions] = React.useState<any | undefined>(undefined)
  const isMobile = useMediaQuery('(max-width: 43em)')
  const collectors = useSubscription<Query_Root>(COLLECTORS_SUBSCRIPTION, {
    variables: {
      mint: video.address,
    },
  }).data
  const purchasesCount = useSubscription<Query_Root>(PURCHASES_SUBSCRIPTION, {
    variables: {
      mint: video.address,
    },
  }).data

  const hasActivity =
    (purchasesCount?.mint[0]?.editionMetadata?.metadataObject?.purchaseReceiptsAggregate?.aggregate
      ?.count || 0) > 0 ||
    (purchasesCount?.mint[0]?.primaryReceiptsAggregate.aggregate?.count || 0) > 0
  const collectorsTokenAccounts: any[] = collectors?.mint[0]?.tokenAccounts || []
  const hasLeaderboard = collectorsTokenAccounts.length > 0

  return (
    <OuterDiv>
      <StyledTabs
        value={index}
        onChange={(_e, newValue) => setIndex(newValue)}
        aria-label="ant example"
        variant="scrollable"
        scrollButtons="auto"
      >
        <StyledTab isMobile={isMobile} label="Comments" />
        {hasLeaderboard ? (
          <StyledTab isMobile={isMobile} label="Leaderboard" />
        ) : (
          <StyledTab isMobile={isMobile} label="" />
        )}
        {hasActivity ? (
          <StyledTab isMobile={isMobile} label="Activity" />
        ) : (
          <StyledTab isMobile={isMobile} label="" />
        )}
      </StyledTabs>
      <SwipeDiv>
        <SwipeableViews
          style={{
            width: '100%',
          }}
          axis={'x'}
          index={index}
          onSwitching={setIndex}
          animateHeight={true}
          action={
            ((actions: any) => {
              setSwipeableActions(actions)
            }) as any
          }
        >
          <CommentsDetails
            updateHeight={() => swipeableActions?.updateHeight()}
            currentIndex={index}
            index={0}
            video={video}
          />
          {hasLeaderboard ? (
            <LeaderboardDetails
              updateHeight={() => swipeableActions?.updateHeight()}
              currentIndex={index}
              index={1}
              video={video}
            />
          ) : (
            <></>
          )}
          {hasActivity ? (
            <ActivityDetails
              updateHeight={() => swipeableActions?.updateHeight()}
              currentIndex={index}
              index={2}
              video={video}
            />
          ) : (
            <></>
          )}
        </SwipeableViews>
      </SwipeDiv>
    </OuterDiv>
  )
}

export default SocialDetails
